import React from 'react';
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { containerVariants, itemVariants } from "../../variants/variants";

const Section3 = () => {
    const { t } = useTranslation();

    const images = Array.from(
        { length: 18 },
        (_, index) => `/images/sustainability/cards/${index + 1}.png`
    );

    return (
        <motion.div 
            initial="hidden"
            whileInView="visible"
            exit="exit"
            variants={containerVariants}
            className="grid grid-cols-3"
        >
            <div className="col-span-3 md:col-span-1 ">
                <motion.h2 
                    variants={itemVariants}
                    className="text-56 mb-5"
                >
                    {t("sustainability.goals.title")}
                    <br />
                    <span className="font-bold">
                        {t("sustainability.goals.subtitle")}
                    </span>
                </motion.h2>

                <motion.p 
                    variants={itemVariants}
                    className="text-20 font-medium text-customGray5"
                >
                    {t("sustainability.goals.description")}
                </motion.p>
            </div>

            <div className="col-span-3 md:col-span-2 grid grid-cols-4 lg:grid-cols-6 md:pl-10 content-start gap-5 w-full my-10 md:my-0">
                {images.map((src, index) => (
                    <motion.div
                        key={index}
                        className="aspect-square bg-red-800"
                        variants={itemVariants}

              
                    >
                        <img src={src} alt={`Sustainability card ${index + 1}`} />
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
}

export default Section3;
